import * as React from 'react';
import Style from './assets/toggleButtonStyle.scss';
import IToggleButtonProps from './entities/IToggleButtonProps';
import { GetIconComponent } from '@bimser/icons';

import classNames from 'classnames/bind';
const cx = classNames.bind(Style);

class BCToggleButton extends React.Component<IToggleButtonProps, any> {
	constructor(props: IToggleButtonProps) {
		super(props);
	}

	onBtnClick = () => {
		const active = !this.props.active;
		if (this.props.onChange) {
			this.props.onChange(active);
		}
	};

	render() {
		const { size, text, icon } = this.props;
		const classNames = cx({
			ToggleButtonContainer: true,
			ToggleOn: this.props.active,
			sizeMedium: size == 'medium',
			sizeLarge: size == 'large'
		});

		return (
			<div
				data-selenium-id={this.props.seleniumId}
				onClick={this.onBtnClick}
				className={classNames}
			>
				{icon && GetIconComponent(icon)}
				{text && <span>{text}</span>}
			</div>
		);
	}
}

export default BCToggleButton;
export { IToggleButtonProps };
